export interface MessageThreadPosition {
	clientHeight: number;
	scrollHeight: number;
	scrollTop: number;
}

export function messageThreadAtBottom(thread: MessageThreadPosition, threshold = 24): boolean {
	return thread.scrollHeight - thread.scrollTop - thread.clientHeight <= threshold;
}
